import React from 'react'
import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import useStyles from './style';
import TopHeaderViewer from './components/TopHeader';
import OverviewCardViewer from './components/OverviewCard';
import ActionBarViewer from './components/ActionBar';
import CardInfoViewer from './components/CardInfo';
import TabsViewer from './components/Tabs';
import BlockRenderer from './components/BlockRenderer';
import FooterViewer from './components/FooterViewer';
import { toast } from 'react-toastify';
import { generateId, clearCurrentChartReduxStore, chatRedirect } from './utils';

const TrackerViewerView = (props) => {
  const { data, formData, appId, orgId } = props;
  const { chartData, chartUniqueId } = data || {};
  const { tabs, overview, actionBar, uploadCard, topBar, selectedDataModel, listPages } = chartData || {};
  const currentDocumentId = props?.match?.params?.id;
  const [json, setJson] = useState({});
  const [blockState, setBlockState] = useState(json)
  const [currentDataModel, setCurrentDataModel] = useState({})
  const [auditTrailDrawerOpen, setAuditTrailDrawerOpen] = useState(false)
  const [auditTrail, setAuditTrail] = useState([])
  const classes = useStyles();
  const [activeTabMain, setActiveTabMain] = useState(Object.keys(tabs?.labels || {})[0] || 'dealReviewDetails');


  useEffect(() => {
    if (currentDocumentId) {
      fetchSingleDocument()
      props.getAuditTrailsData({
        dataModelId: selectedDataModel,
        appId: props.match.params.appid,
        documentId: props.match.params.id,
        dataUniqueId: chartUniqueId + '_audit_Trails_Documents'
      })
    }
    if (!currentDocumentId) {
      setBlockState({
        dealReviewId: generateId('Deal Review')
      })
    }
    fetchDataModel()
    return (() => {
      clearCurrentChartReduxStore(props, [
        props.data.chartUniqueId + '_getsingledocument',
        props.data.chartUniqueId + '_audit_Trails_Documents',
        props.data.chartUniqueId + '_update',
        props.data.chartUniqueId + '_save',

      ])
    })
  }, [])

  useEffect(() => {
    if (props.formData?.document[chartUniqueId + '_getsingledocument']) {
      let obj = props.formData?.document[chartUniqueId + '_getsingledocument'] || {}
      setJson(obj);
      setBlockState(obj)
    }
  }, [props.formData?.document[chartUniqueId + '_getsingledocument']])

  useEffect(() => {
    if (props.formData?.auditTrails?.[chartUniqueId + '_audit_Trails_Documents']) {
      let obj = props.formData?.auditTrails[chartUniqueId + '_audit_Trails_Documents'] || {}
      setAuditTrail(obj)
    }
  }, [props.formData?.auditTrails?.[chartUniqueId + '_audit_Trails_Documents']])

  useEffect(() => {
    const saveResponse = props.formData?.document?.[chartUniqueId + '_save'];
    if (saveResponse && saveResponse?.data?.[0]?._id) {
      let res = saveResponse?.data?.[0];
      console.log('saveResponse**saveResponse', saveResponse, res)
      if (res && Object.keys(res).length > 0) {
        toast.success(res.message || 'Document Created Successfully')
        props.clearReduxDataOfCurrentComponent({
          key: 'document',
          subKey: [`${chartUniqueId}_save`]
        })
        chatRedirect(props.history, props.match.params.appid, listPages)
      }
    }
  }, [props.formData?.document?.[chartUniqueId + '_save']])

  useEffect(() => {
    if (currentDocumentId) {
      const updateResponse = props.formData?.document?.[chartUniqueId + '_update'];
      if (updateResponse && updateResponse?._id) {
        let res = updateResponse;
        if (res && Object.keys(res).length > 0) {
          toast.success(res.message || 'Document Updated Successfully')
          setBlockState(res)
          props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${chartUniqueId}_update`]
          })
        }
      }
    }
  }, [props.formData?.document?.[chartUniqueId + '_update']])


  const fetchDataModel = () => {
    let payload = {
      appid: props.appId,
      orgId: props.orgId
    }
    if (selectedDataModel) {
      if (!formData?.dataModel?.[selectedDataModel]) {
        if (!formData?.dataModel?.[selectedDataModel] && !formData[`${selectedDataModel}_loading`]) {
          payload['dataModelId'] = selectedDataModel
          payload['dataUniqueId'] = selectedDataModel
          props.getDataModelById(payload)
        }
      } else {
        setCurrentDataModel(formData?.dataModel?.[selectedDataModel])
      }
    }
  }

  const fetchSingleDocument = () => {
    if (!props.formData?.document[chartUniqueId + '_getsingledocument']) {
      let payload = {
        appId: appId,
        orgId: orgId,
        dataModelId: selectedDataModel,
        opportunityId: currentDocumentId,
        dataUniqueId: chartUniqueId + '_getsingledocument'
      }
      props.getSingleOpportunity(payload)
    }
  }

  const handleAuditTrailDrawerToggle = () => {
    setAuditTrailDrawerOpen(!auditTrailDrawerOpen)
  }

  const handleExport = (id, item) => {
    let payload = {
      dataModelId: selectedDataModel,
      appid: props.match.params.appid,
      fields: actionBar?.ActionButton?.export?.exportdataElement?.map(i => i.value).join(","),
      ids: [id],
      downloadType: 'excel',
      dataUniqueId: props.data.chartUniqueId + '_' + currentDocumentId + '_download_single_document',
    }
    props.downloadSheet(payload);
  }

  const onChange = (key, value) => {
    let newBlockState = { ...blockState }
    newBlockState[key] = value
    setBlockState(newBlockState)
  }

  const handleCheckboxChange = (value) => {
    console.log('handleCheckboxChange**handleCheckboxChange', value)
  }

  const saveData = () => {
    let data = Object.assign({}, blockState)
    let formData = {
      appid: props.match.params.appid,
      dataModelId: chartData?.selectedDataModel,
      payload: {
        ...data,
        status: 'Active'
      }
    }
    if (currentDocumentId) {
      let blockStateObject = JSON.parse(JSON.stringify(data))
      if (blockStateObject['_id']) {
        blockStateObject['id'] = blockStateObject['_id'];
        delete blockStateObject._id;
      }
      let payloadData = {
        appId: props.match.params.appid,
        dataModelId: selectedDataModel,
        dataUniqueId: chartUniqueId + '_update',
        opportunityId: currentDocumentId,
        payload: {
          ...blockStateObject
        }
      }
      props.updateOpportunity(payloadData);
    } else {
      console.log('data**data', data)
      if (Object.keys(data).length === 1) {
        toast.error('Please fill all the details before saving')
        return;
      }
      formData['dataUniqueId'] = chartUniqueId + '_save'
      props.createDocument(formData)
    }
  }

  return (
    <div className={classes.container}>
      <Grid container className={classes.headerGrid}>
        <Grid item xs={12} className={classes.headerRow}>
          <TopHeaderViewer {...props} blockState={blockState} isUpdated={currentDocumentId ? true : false} listPages={listPages}/>
          <OverviewCardViewer {...props} src={overview?.src} data={overview} isUpdated={currentDocumentId ? true : false} />
          <ActionBarViewer {...props} isButtonEnable={actionBar?.ActionButton?.enable} isExport={actionBar?.ActionButton?.export?.enable} isAuditTrail={actionBar?.ActionButton?.auditTrail?.enable} handleAuditTrailDrawerToggle={handleAuditTrailDrawerToggle} auditTrailDrawerOpen={auditTrailDrawerOpen} auditTrail={auditTrail} chartUniqueId={chartUniqueId} label={actionBar?.actionHeader?.label} value={actionBar?.actionHeader?.value} blockState={blockState} exportLabel={actionBar?.ActionButton?.export?.label} auditTrailLabel={actionBar?.ActionButton?.auditTrail?.label} handleExport={handleExport} isUpdated={currentDocumentId ? true : false} currentDocumentId={currentDocumentId} />
          <CardInfoViewer {...props} data={uploadCard?.dataElement} blockState={blockState} />
          <TabsViewer {...props} tabs={tabs} setActiveTabMain={setActiveTabMain} activeTabMain={activeTabMain} />
          {
            activeTabMain === 'dealReviewDetails' && (
              <div className={classes.dealReviewDetails}>
                <BlockRenderer blocks={tabs?.dealReviewDetails?.blocks} blockState={blockState} {...props} onChange={onChange}
                  handleCheckboxChange={handleCheckboxChange} selectedDataModel={selectedDataModel} />
              </div>
            )
          }
          <FooterViewer saveData={saveData} blockState={blockState} {...props} isUpdated={currentDocumentId ? true : false} listPages={listPages}/>
        </Grid>
      </Grid>
    </div>
  )
}

export default TrackerViewerView